import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Inject,
    Input,
    NgZone,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { OnDestroy$ } from '@pdtec/ngx-observable-lifecycle';
import { HTTPSearchResultTour, ITouristsParams } from 'src/app/models';
import { environment } from '../../../../environments/environment';
import { HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig } from '../../../config/hotel-tours-list-page.config';
import { TourViewLinkService } from '../../../services/tour-view-link.service';
import { ToursStateService } from '../../../services/tours-state.service';
import { WindowRefService } from '../../../services/window-ref.service';
import { HotelRatingComponent } from '../../hotel-rating/hotel-rating.component';
import { HotelStarsComponent } from '../../hotel-stars/hotel-stars.component';
import { PriceFormatPipe } from '../../pipes/price-format/price-format.pipe';
import { HotelWishlistComponent } from '../hotel-wishlist/hotel-wishlist.component';
import { TourImageComponent } from '../tour-image/tour-image.component';
import { HotelServicesComponent } from '../tour-info/hotel-services/hotel-services.component';
import { TourInfoComponent } from '../tour-info/tour-info.component';
import { TourPricesComponent } from '../tour-prices/tour-prices.component';

@Component({
    selector: 'app-tour',
    templateUrl: environment.mobile ? './tour.component.mobile.html' : './tour.component.html',
    styleUrls: environment.mobile ? ['./tour.component.mobile.scss'] : [
        './tour.component.scss',
        '../../../../../../../build/assets/desktop/_include/scss/tour-card-title.scss',
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CommonModule,
        TourImageComponent,
        HotelRatingComponent,
        HotelStarsComponent,
        TourInfoComponent,
        HotelServicesComponent,
        TourPricesComponent,
        HotelWishlistComponent,
        PriceFormatPipe
    ]
})
export class TourComponent extends OnDestroy$ implements OnInit, OnDestroy {
    @Input() tour: HTTPSearchResultTour;
    @Input() index: number;
    @Input() state: ToursStateService;
    @Input() wishlistHotels: number[] = [];

    @ViewChild('viewLink') public viewLinkRef!: ElementRef;

    touristsLabel: string;

    daysFrom: number = null;
    daysTo: number = null;
    departDateFrom: string = null;
    departDateTo: string = null;
    messages: any = {};

    constructor(
        @Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig,
        private ngZone: NgZone,
        private ch: ChangeDetectorRef,
        private tourViewLink: TourViewLinkService,
        private window: WindowRefService,
    ) {
        super();
        this.messages = {
            moreDetails: this.hotelToursPageConfig.translates.moreDetails,
            combiTour: this.hotelToursPageConfig.translates.tourInfo['combiTour']
        };
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
    }

    get viewHref(): string {
        return this.tourViewLink.getHref(this.tour);
    }

    tourViewClick() {
        this.window.nativeWindow.brxTracking.sendAnalyticsEvent('click_on_the_hotel_in_the_search_results_mobile');
    }

    /**
     * Костыль для перехода
     * Геморой со слайдером. Если ссылку позиционировать поверх слайдера - ломается обработка тачей
     * Писать свой detect когда нужен слайдер и не нужен клик такое себе
     * Трогать слайдер тоже не хочется лишний раз
     * Пока таким костылем
     */
    public openTourView(): void {
        if (this.viewLinkRef) {
            this.viewLinkRef.nativeElement.click();
        }
    }

    // Кнопка "Показать туры"
    onShowTours(touristsParams: ITouristsParams) {
        // this.isSameToursOpen = !this.isSameToursOpen;
        // // Если false - то значит закрыли, поиск новый не запускаем
        // if (!this.isSameToursOpen) {
        //   return null;
        // }

        // if (!this.isManualHotOffer && this.tour.hotel.id !== 0) {
        //   this.sameTours = [];
        // }

        // this.isSearchRunning = true;
        // this.searchTours(touristsParams).subscribe(() => {
        //   this.ngZone.run(() => {
        //     this.isSearchRunning = false;
        //     if (environment.mobile) {
        //       setTimeout(() => {
        //         scrollToElement($(this.variants.element.nativeElement), 50);
        //       }, 200);
        //     }
        //     this.ch.markForCheck();
        //   });
        // });
    }

    // Пересчет количества
    onRecalcTour(touristsParams: ITouristsParams) {
        //   this.isSameToursOpen = false;
        //   this.sameTours = [];

        //   this.isSearchRunning = true;
        //   this.searchTours(touristsParams).subscribe(tours => {
        //     this.ngZone.run(() => {
        //       this.isSearchRunning = false;

        //       if (tours.length) {
        //         this.isSameToursOpen = true;
        //         this.eventBusService.recalcFoundTours$.next();
        //         if (environment.mobile) {
        //           setTimeout(() => {
        //             scrollToElement($(this.variants.element.nativeElement), 50);
        //           }, 200);
        //           close_popup('#ng-modal-recalc');
        //         }
        //       } else {
        //         this.isSearchRunning = false;
        //         this.isSameToursOpen = true;
        //         this.eventBusService.toursNotFoundOnRecalc$.next();
        //       }
        //       this.ch.markForCheck();
        //     });
        //   });
        // }

        // // Поиск туров
        // private searchTours(touristsParams: ITouristsParams): Observable<Tour[]> {
        //   this.touristsLabel = this.getTouristsLabel(touristsParams);
        //   // Устанавливаем диапазоны поиска
        //   const extendsQueryParams: Partial<SearchQuery> = {
        //     nightsFrom: this.#searchDaysFrom - 1,
        //     // Дополнительно ищем на +2 ночи
        //     nightsTo: this.#searchDaysTo + 2,
        //     dateFrom: new Date(this.#searchDepartDateFrom),
        //     dateTo: new Date(this.#searchDepartDateTo),
        //   };

        //   // Если у нас поиск, то мы даты берем по форме поиска
        //   if (this.hotelToursPageConfig.mode === MODE.MODE_SEARCH) {
        //     extendsQueryParams.dateFrom = this.searchService.lastSearchParams.dateFrom;
        //     extendsQueryParams.dateTo = this.searchService.lastSearchParams.dateTo;
        //     extendsQueryParams.nightsFrom = this.searchService.lastSearchParams.nightsFrom;
        //     extendsQueryParams.nightsTo = this.searchService.lastSearchParams.nightsTo;
        //   }
        //   let isOnlyHotels = false;
        //   if (!this.tour.departCity.id) {
        //     isOnlyHotels = true;
        //   }

        //   if (this.searchService.isExpandDate && this.hotelToursPageConfig.mode !== MODE.MODE_SEARCH) {
        //     this.searchService.expandParams(extendsQueryParams);
        //   }
        //   if (this.isManualHotOffer || this.tour.hotel.id === 0) {
        //     return new Observable(observer => {
        //       if (this.sameTours.length) {
        //         this.tour = this.sameTours[0];
        //       }
        //       observer.next(this.sameTours);
        //     });
        //   }

        //   const operatorMeal = pipe(
        //     map((tours: Tour[]) => {
        //       const mealsFilter = this.serviceFilters.find(filterOption => filterOption.type === FilterTypes.MEALS);
        //       if (mealsFilter.selectedValues.length) {
        //         const selectedValues = mealsFilter.selectedValues.map((value: any) => {
        //           return value.toString().toLocaleLowerCase();
        //         });
        //         tours = tours.filter(tour => selectedValues.indexOf(tour.meal.name.toLocaleLowerCase()) !== -1);
        //       }

        //       return tours;
        //     }),
        //   );

        //   return this.recalcService.recalc(this.tour, touristsParams, isOnlyHotels, extendsQueryParams).pipe(
        //     reduce((acc, tours) => acc.concat(tours), []),
        //     map(tours =>
        //       tours.sort((tour1: Tour, tour2: Tour) => {
        //         if (tour1.price.forOne < tour2.price.forOne) {
        //           return -1;
        //         }
        //         if (tour1.price.forOne > tour2.price.forOne) {
        //           return 1;
        //         }

        //         return 0;
        //       }),
        //     ),
        //     // operatorMeal,
        //     map((tours: Tour[]) => {
        //       // Обновляем коллекции
        //       this.toursCollectionService.updateSameTours(this.tour, tours);
        //       // Вытаскиваем перегруппированные и отсортированные как нам нужно
        //       let findTours = this.toursCollectionService.getSameToursByTour(this.tour);
        //       findTours = findTours.map((tours: Array<Array<Tour>>) => {
        //         // Первый в группе всегда минимальный
        //         return tours[0];
        //       });

        //       return findTours;
        //     }),
        //     tap((tours: Tour[]) => {
        //       this.sameToursCount = tours.length;
        //       if (tours.length) {
        //         this.sameTours = tours;
        //         // Тур с минимальной ценой делаем основным
        //         this.tour = this.sameTours[0];
        //         this.calculateInformation(this.sameTours, false);
        //       } else {
        //         this.isShowPrice = false;
        //       }
        //       this.touristsService.recalcTourists.set(this.tour.id, touristsParams);
        //     }),
        //   );
    }

    get isWishlist() {
        return this.hotelToursPageConfig.isWishlist;
    }

    get mainPhotoSrc(): string {
        if (this.tour.photo) {
            return `${this.hotelToursPageConfig.photoBasePath}/${this.tour.photo}`;
        }

        return this.hotelToursPageConfig.noPhotoLink;
    }

    get hotelName(): string {
        return this.tour.hotelName.toLowerCase().replace('&amp;', '&');
    }

    get cashback(): number {
        const price = this.tour.price.value;
        const maxCashback = 120000;
        const minCashback = 15000;

        if (price > 1000000) {
            const cashback = Math.floor(price / 500000) * 6850;
            return Math.min(Math.max(cashback, minCashback), maxCashback);
        }

        const cashback = Math.ceil(price * 2 / 100);
        return Math.min(cashback, minCashback);
    }
}
